var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Direction, Size } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { array, bool, expression, formatters, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, isEmptyOrBlankString } from '@philips-internal/oswald-ui-utils';
import { InlineImage } from '../inline-image/inline-image.js';
import AvatarAPI from './avatar-api.js';
import './avatar.css';
const DEFAULT_IMAGE = '/static/assets/components/DLS_PersonPortraitCircle.svg';
let Avatar = class Avatar extends Component {
    constructor() {
        super(...arguments);
        this.renderData = () => {
            const { formatters, subtitleHiddenOnMobile } = this.props;
            const { description, subtitle, title } = ModelService.formatProps(this.props, ['description', 'subtitle', 'title'], formatters);
            const showData = (title.length > 0 || subtitle.length > 0);
            const subtitleClasses = {
                'c-avatar__subtitle': true,
                'u-hide@xsm': Boolean(subtitleHiddenOnMobile),
            };
            const subtitleClassName = classNames(subtitleClasses);
            return !showData ? null : (React.createElement("div", { className: "c-avatar__data" },
                title && React.createElement("span", { className: "c-avatar__title" }, MessageService.translate(title)),
                subtitle && React.createElement("span", { className: subtitleClassName }, MessageService.translate(subtitle)),
                description && React.createElement("span", { className: "c-avatar__description" }, MessageService.translate(description))));
        };
    }
    renderImage() {
        const { hideImage, image, showImageBorder } = this.props;
        if (hideImage) {
            return null;
        }
        const noImage = isEmptyOrBlankString(image);
        const src = noImage ? DEFAULT_IMAGE : image;
        const className = classNames({
            'c-avatar__image': true,
            'c-avatar__image--border': showImageBorder,
            'c-avatar__image--default': noImage,
        });
        return React.createElement(InlineImage, { className: className, src: src });
    }
    render() {
        const { className, direction, directionBreakpoints, size, sizeBreakpoints } = this.props;
        const avatarClasses = {
            'c-avatar': true,
            [`${className}`]: Boolean(className),
            [`c-avatar--${direction}`]: directionBreakpoints.length === 0,
            [`c-avatar--${size}`]: sizeBreakpoints.length === 0,
        };
        const avatarBreakpoints = {
            [`c-avatar--${direction}`]: directionBreakpoints,
            [`c-avatar--${size}`]: sizeBreakpoints,
        };
        return (React.createElement("div", { className: classNames(avatarClasses, avatarBreakpoints) },
            this.renderImage(),
            this.renderData()));
    }
};
Avatar.propTypes = {
    className: string,
    description: expression,
    direction: oneOf(enumValues(Direction)),
    directionBreakpoints: array.notEnumerable(),
    formatters: formatters,
    hideImage: bool.group('image'),
    image: string.group('image'),
    showImageBorder: bool.group('image'),
    size: oneOf(enumValues(Size)),
    sizeBreakpoints: array.notEnumerable(),
    subtitle: expression,
    subtitleHiddenOnMobile: bool,
    title: expression,
};
Avatar.defaultProps = {
    direction: Direction.HORIZONTAL,
    directionBreakpoints: [],
    hideImage: false,
    image: '',
    showImageBorder: false,
    size: Size.MEDIUM,
    sizeBreakpoints: [],
    subtitle: '',
    subtitleHiddenOnMobile: false,
    title: '',
};
Avatar = __decorate([
    AwesomeComponent({ api: AvatarAPI, type: ComponentType.DATA_DISPLAY })
], Avatar);
export { Avatar, };
export default Avatar;
//# sourceMappingURL=avatar.js.map